module.exports = __webpack_public_path__ + "static/media/copper_medal.5bd3fd4b.png";